import { render } from "./FooterComponent.vue?vue&type=template&id=12564a5c"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=12564a5c&lang=css"

import exportComponent from "E:\\GCM3\\Demo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__